import type { FC, ReactNode } from 'react'
import type { TagDetailPageProps } from '@/lib/tag-pages'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { tagDetailProps } from '@/lib/tag-pages'
import TagDetailView from '@/components/kb/tag-detail-view'

const SamagriPage: FC<TagDetailPageProps> = ({ data }): ReactNode => {
    const description = data.tag.description ?? `Every remedy, method, brahmastra and answer from the Geo Vastu courses that uses ${data.tag.name}.`

    return (
        <Layout>
            <Seo title={data.tag.name} description={description} />

            <TagDetailView data={data} />
        </Layout>
    )
}

export const getServerSideProps = tagDetailProps('samagri')

export default SamagriPage
